/** Preserve meaningful hues while keeping them readable against pure white. */
export function readableBoardColor(value: string | undefined, fallback = '#111827') {
  if (!/^#[0-9a-f]{6}$/i.test(value || '')) return fallback;
  let channels = [1, 3, 5].map(offset => parseInt(value!.slice(offset, offset + 2), 16));
  const luminance = () => channels.map(c => {
    const s = c / 255;
    return s <= .04045 ? s / 12.92 : ((s + .055) / 1.055) ** 2.4;
  }).reduce((sum, c, i) => sum + c * [.2126, .7152, .0722][i], 0);
  while (1.05 / (luminance() + .05) < 4.5) channels = channels.map(c => Math.floor(c * .85));
  return `#${channels.map(c => c.toString(16).padStart(2, '0')).join('')}`;
}